<!-- eslint-disable vue/multi-word-component-names -->
<template>

  <el-row :span="24">
    <el-col :span="24">
      <div class="row m-0">

        <el-row :span="24" class="m-0">
        <el-col
          :span="
            hasGroupBy &&
            timeOfDayGroupByListProp != null &&
            timeOfDayGroupByListProp.length > 0
              ? $vuetify.display.width >= 1200
                ? 8
                : 24
              : $vuetify.display.width >= 500
              ? 24
              : 24
          "
          class="d-flex align-item-center"
          :class="
            $vuetify.display.width < 500
              ? 'x-center mt-2'
              : hasPeriod == true
              ? 'justify-end'
              : ''
          "
        >
          <div class="m-0" >
            <!-- Delete Sessions Filter button -->
            <el-tooltip
              effect="light"
              placement="top"
              show-after="500"
              hide-after="300"
              >
              <template #content >
                  <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Refresh monitoring periods data" }} </span>
              </template>
            <el-button
              v-if="hasCustomDate"
              color="#0D3937"
              class="height-40 border-color-light rounded-3"
              @click="customDate = !customDate"
            >
              <svg class="stroke-icon width-20 height-20">
                <use href="@/assets/svg/icon-sprite.svg#stroke-date"></use>
              </svg>
              <span class="text-white pl-3"> Delete Unallocated Sessions </span>
            </el-button>
            </el-tooltip>
          </div>
        </el-col>
        </el-row>
      </div>
    </el-col>



    <el-col :span="24">

    <!-- delete session filter -->
    <el-row  class="y-center m-0 p-l-20 py-3 ">

      <el-col :span="24">
      <div
        class="row y-center mt-2 p-2 bg-me-primary border-color-light rounded-4 width-100-p"
      >
                <el-col :span="$vuetify.display.width >= 1200 ? 24 : $vuetify.display.width >= 500 ? 24 : 24">
          <label class="radio-label font-12" :style="{'max-width': $vuetify.display.width <= 1485 ? 'auto' : $vuetify.display.width <= 1578 ? '400px' : $vuetify.display.width <= 1651 ? '450px' : '500px'}">
            <template v-if="selectedDeleteBy === 'created_at'">
              * Select a customer and optionally filter by upload date range to remove unallocated sessions.
            </template>
            <template v-else>
              * Please select the time period and method for removing unallocated sessions.
            </template>
          </label>
      </el-col>

        <el-form :label-position="`top`" class="text-center">
            <el-col v-if="selectedDeleteBy !== 'created_at'" :span="24">
                <el-radio-group
                  v-model="selectTimePeriod"
                  label= "Select Time Period"
                  class="p-10 mb-2"
                  >
                  <!-- <el-radio :disabled="!showCMP" label="current_mp" @click="switchTimePeriod('current_mp')">Current MP</el-radio>
                  <el-radio :disabled="!showRMP" label="revision_mp" @click="switchTimePeriod('revision_mp')">Revision MP</el-radio> -->
                  <el-radio  label="current_mp" @click="switchTimePeriod('current_mp')">Pre-Audit MP</el-radio>
                  <el-radio label="revision_under_audit_mp" @click="switchTimePeriod('revision_under_audit_mp')">Revision Under Audit MP</el-radio>
                  <el-radio label="revision_issue_requested_mp" @click="switchTimePeriod('revision_issue_requested_mp')">Revision Issue Requested MP</el-radio>
                </el-radio-group>
              </el-col>

              <el-col v-if="selectedDeleteBy !== 'created_at'" :span="24">
              <!-- select charger dropdown end -->
              <div class="mt-2 align-center" v-if="1==1">
                  <!-- new MP dropdown -->
                     <el-select
                         v-model="selectedMonitorPeriodId"
                         placeholder="Select Monitoring Period for Unallocated Session Deletion"
                         class="custom-filter-select w-50"
                         :loading="abatementSessionsLoading"
                         @change="handleSelectedMP(selectedMonitorPeriodId)"
                         >
                         <!-- Render the header row once -->
                         <template v-if="fetchedTimePeriod.length > 0">
                          <div class="option-content option-header" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                            <span class="option-item">Name</span>
                            <span class="option-item">Start Date</span>
                            <span class="option-item">End Date</span>
                            <span class="option-item">Status</span>
                          </div>
                        </template>
                        <el-option
                      v-for="item in fetchedTimePeriod"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                      <div class="option-content option-row" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                        <span class="option-item">{{ item.name }}</span>
                        <span class="option-item">{{ item.start_date.split('T')[0] }}</span>
                        <span class="option-item">{{ item.end_date.split('T')[0] }}</span>
                        <span class="option-item">{{ item.status.replaceAll('_', ' ').toUpperCase() }}</span>
                      </div>
                    </el-option>
                     </el-select>
                </div>
                <!-- new mp dropdown end -->
            </el-col>

          
              <!-- delete session datetime picker -->
          <el-space  v-if="showTimePicker && selectedDeleteBy !== 'created_at'"   fill style="width: 100%">
            <el-row gutter=20 class="mb-10">
              <el-col
                :class="$vuetify.display.width <= 500 ? 'px-0' : 'pl-0'"
                :span="
                  $vuetify.display.width >= 1400
                    ? 8
                    : $vuetify.display.width <= 500
                    ? 24
                    : 12
                "
                :offset="$vuetify.display.width >= 1400 ? 4 : 0"
              >
                <el-form-item class="label-style mb-1" label="Start Date : ">
                  <el-date-picker
                    v-model="tempStartDate"
                    type="datetime"
                    placeholder="Pick a start date and time"
                    size="default"
                    class="w-100"
                    format="DD/MM/YYYY HH:mm:ss"
                    date-format="DD/MM/YYYY"
                    time-format="HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="updateDate('start')"
                    @cancel="resetTempDate('start')"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :class="$vuetify.display.width <= 500 ? 'px-0 pt-10' : 'pr-0'"
                :span="
                  $vuetify.display.width >= 1400
                    ? 8
                    : $vuetify.display.width <= 500
                    ? 24
                    : 12
                "
              >
                <el-form-item class="label-style mb-1" label="End Date : ">
                  <el-date-picker
                    v-model="tempEndDate"
                    type="datetime"
                    placeholder="Pick a end date and time"
                    size="default"
                    class="w-100"
                    format="DD/MM/YYYY HH:mm:ss"
                    date-format="DD/MM/YYYY"
                    time-format="HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="updateDate('end')"
                    @cancel="resetTempDate('end')"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-space>




          <el-space
            class="mt-3"
            fill
            style="width: 100%"
            v-if="
              hasCharger ||
              ($store.state.auth.user != null && $store.state.auth.user.is_admin)
            "
          >
            <!-- delete session checkbox -->
            <el-row gutter=20>

              <el-col class="x-center" :span="$vuetify.display.width >= 1200 ? 24 : $vuetify.display.width >= 500 ? 24 : 24">
                <el-radio-group
                  v-model="selectedDeleteBy"
                  label= "Select delete By"
                  class="p-10"
                  >
                  <el-radio label="customer" >Customer</el-radio>
                  <el-radio label="charger" >Charger</el-radio>
                  <el-radio label="site" >Charger Site</el-radio>
                  <el-radio label="port" >Charger Port</el-radio>
                  <el-radio label="created_at" >Created At Date</el-radio>
                </el-radio-group>
              </el-col>

              <!-- delete by created at date -->
              <template v-if="selectedDeleteBy === 'created_at'">
                <el-col :span="24" class="x-center mt-20">
                  <el-form-item
                    class="label-style"
                    prop="customer"
                    label="Customer : "
                  >
                    <el-select
                      clearable
                      v-model="filter.customer_id"
                      placeholder="Select Customer"
                      :style="$vuetify.display.width <= 800 ? 'max-width: 100%; min-width: 200px;' :  $vuetify.display.width <= 1400 ? 'max-width: 95%; min-width: 400px; padding-right: 10px;' : 'max-width: 95%; padding-right: 10px; min-width: 400px;'"
                      class="w-100"
                      @change="handleCreatedAtCustomerChange"
                    >
                      <template v-if="customers.length > 0">
                        <div class="option-content option-header">
                          <span class="option-item">Name</span>
                          <span class="option-item">Phone</span>
                        </div>
                      </template>
                      <el-option
                        v-for="(item, index) in customers"
                        :key="item.id || index"
                        :label="item.full_name || 'undifined'"
                        :value="item.id || 'undifined'"
                      >
                        <div class="option-content option-row">
                          <span class="option-item">{{ item.full_name }}</span>
                          <span class="option-item">{{ item.phone }}</span>
                        </div>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="24" class="mt-10 x-center">
                  <el-form-item
                    class="custom-filter-item label-style mb-1"
                    label="Date Range (optional) : "
                  >
                    <el-date-picker
                      class="custom-filter-date-picker"
                      v-model="createdAtDateTimeRange"
                      type="datetimerange"
                      start-placeholder="Start date"
                      end-placeholder="End date"
                      range-separator="To"
                      format="DD/MM/YYYY HH:mm:ss"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      unlink-panels
                      @change="handleCreatedAtDateRangeChange"
                    >
                      <template #prev-month>
                        <el-icon><CaretLeft /></el-icon>
                      </template>
                      <template #next-month>
                        <el-icon><CaretRight /></el-icon>
                      </template>
                      <template #prev-year>
                        <el-icon>
                          <svg
                            viewBox="0 0 20 20"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g stroke-width="1" fill-rule="evenodd">
                              <g fill="currentColor">
                                <path
                                  d="M8.73171,16.7949 C9.03264,17.0795 9.50733,17.0663 9.79196,16.7654 C10.0766,16.4644 10.0634,15.9897 9.76243,15.7051 L4.52339,10.75 L17.2471,10.75 C17.6613,10.75 17.9971,10.4142 17.9971,10 C17.9971,9.58579 17.6613,9.25 17.2471,9.25 L4.52112,9.25 L9.76243,4.29275 C10.0634,4.00812 10.0766,3.53343 9.79196,3.2325 C9.50733,2.93156 9.03264,2.91834 8.73171,3.20297 L2.31449,9.27241 C2.14819,9.4297 2.04819,9.62981 2.01448,9.8386 C2.00308,9.89058 1.99707,9.94459 1.99707,10 C1.99707,10.0576 2.00356,10.1137 2.01585,10.1675 C2.05084,10.3733 2.15039,10.5702 2.31449,10.7254 L8.73171,16.7949 Z"
                                />
                              </g>
                            </g>
                          </svg>
                        </el-icon>
                      </template>
                      <template #next-year>
                        <el-icon>
                          <svg
                            viewBox="0 0 20 20"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g stroke-width="1" fill-rule="evenodd">
                              <g fill="currentColor">
                                <path
                                  d="M11.2654,3.20511 C10.9644,2.92049 10.4897,2.93371 10.2051,3.23464 C9.92049,3.53558 9.93371,4.01027 10.2346,4.29489 L15.4737,9.25 L2.75,9.25 C2.33579,9.25 2,9.58579 2,10.0000012 C2,10.4142 2.33579,10.75 2.75,10.75 L15.476,10.75 L10.2346,15.7073 C9.93371,15.9919 9.92049,16.4666 10.2051,16.7675 C10.4897,17.0684 10.9644,17.0817 11.2654,16.797 L17.6826,10.7276 C17.8489,10.5703 17.9489,10.3702 17.9826,10.1614 C17.994,10.1094 18,10.0554 18,10.0000012 C18,9.94241 17.9935,9.88633 17.9812,9.83246 C17.9462,9.62667 17.8467,9.42976 17.6826,9.27455 L11.2654,3.20511 Z"
                                />
                              </g>
                            </g>
                          </svg>
                        </el-icon>
                      </template>
                    </el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col v-if="selectedCustomer.customer_id" :span="24" class="mt-20">
                  <div
                    class="custom-table-design"
                    v-loading="createdAtListLoading"
                  >
                    <el-table
                      :data="sessionLogsByCreatedAt"
                      stripe
                      :fit="true"
                      height="300"
                      class="my-2 data-table"
                      scrollbar-always-on: false
                    >
                      <el-table-column
                        label="Upload Date"
                        prop="created_at_date"
                        sortable
                      />
                      <el-table-column
                        label="Total Records"
                        prop="total_session_logs"
                        sortable
                      />
                      <el-table-column
                        v-if="$vuetify.display.width < 750"
                        label="Operations"
                        prop="operations"
                        align="center"
                        width="150"
                      >
                        <template #default="scope">
                          <el-tooltip placement="top" effect="light">
                            <template #content>View Details</template>
                            <el-button
                              @click.stop="handleViewCreatedAtPreview(scope.row.created_at_date)"
                              size="small"
                              class="height-25 rounded-2 m-0 ml-2"
                              color="#DDF0AC"
                              style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                            >
                              <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationMoreInfo"></use>
                              </svg>
                            </el-button>
                          </el-tooltip>
                          <el-tooltip placement="top" effect="light">
                            <template #content>Delete</template>
                            <el-button
                              v-if="
                                $store.state.auth.user != null &&
                                !$store.state.auth.user.is_auditor
                              "
                              @click.stop="handleDeleteByCreatedAt(scope.row)"
                              size="small"
                              class="height-25 rounded-2 m-0 ml-2"
                              color="#DDF0AC"
                              style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                            >
                              <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                              </svg>
                            </el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                      <el-table-column
                        v-else
                        fixed="right"
                        label="Operations"
                        prop="operations"
                        align="center"
                        width="250"
                      >
                        <template #default="scope">
                          <el-tooltip placement="top" effect="light">
                            <template #content>View Details</template>
                            <el-button
                              @click.stop="handleViewCreatedAtPreview(scope.row.created_at_date)"
                              size="small"
                              class="height-25 rounded-2 m-0 ml-2"
                              color="#DDF0AC"
                              style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                            >
                              <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationMoreInfo"></use>
                              </svg>
                            </el-button>
                          </el-tooltip>
                          <el-tooltip placement="top" effect="light">
                            <template #content>Delete</template>
                            <el-button
                              v-if="
                                $store.state.auth.user != null &&
                                !$store.state.auth.user.is_auditor
                              "
                              @click.stop="handleDeleteByCreatedAt(scope.row)"
                              size="small"
                              class="height-25 rounded-2 m-0 ml-2"
                              color="#DDF0AC"
                              style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                            >
                              <svg style="width: 24px; height: 24px;">
                                <use href="@/assets/svg/newSvgIcon.svg#tableOperationDelete"></use>
                              </svg>
                            </el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-col>
              </template>
              <!-- delete by created at date end -->

              <el-col v-if="selectedDeleteBy=='customer' &&
                  (filter.startDate && filter.endDate)" :span="24" class="x-center mt-20">
                <el-form-item
                  class="label-style"
                  prop="customer"
                  label="Customer : "

                >
                  <el-select
                    clearable
                    v-model="filter.customer_id"
                    placeholder="Select Customer"
                    :style="$vuetify.display.width <= 800 ? 'max-width: 100%; min-width: 200px;' :  $vuetify.display.width <= 1400 ? 'max-width: 95%; min-width: 400px; padding-right: 10px;' : 'max-width: 95%; padding-right: 10px; min-width: 400px;'"
                    class="w-100"
                    :disabled="selectTimePeriod === ''"
                  >
                    <!-- Render the header row once -->
                  <template v-if="customers.length > 0">
                    <div class="option-content option-header">
                      <span class="option-item">Name</span>
                      <span class="option-item">Phone</span>
                    </div>
                  </template>
                    <el-option
                      v-for="(item, index) in customers"
                      :key="item.id || index"
                      :label="item.full_name || 'undifined'"
                      :value="item.id || 'undifined'"
                      @click="handleSelectCustomer(item.id, item.full_name)"
                    >
                      <div class="option-content option-row">
                        <span class="option-item">{{ item.full_name }}</span>
                        <span class="option-item">{{ item.phone }}</span>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>

              </el-col>

            <el-row :span="24" class='m-0 p-0' style="width: 100%" v-if="selectedDeleteBy !== 'created_at' && selectedDeleteBy !== 'customer' &&
                  (filter.startDate && filter.endDate)">


              <!-- select customer dropdown -->
              <el-col
                class="pl-0 mt-20"
                :style="$vuetify.display.width <= 800 ? 'max-width: 100%; ' :  $vuetify.display.width <= 1400 ? 'max-width: 95%; padding-right: 10px;' : 'max-width: 95%; padding-right: 10px;'"
                :span="
                  $vuetify.display.width >= 1400
                    ? 8
                    : $vuetify.display.width > 800
                    ? 12
                    : 24
                "
                :offset="$vuetify.display.width >= 1400 ? 4 : 0"
                v-if="
                  hasCustomer &&
                  $store.state.auth.user != null &&
                  $store.state.auth.user.is_admin
                "
              >
                <el-form-item
                  class="label-style"
                  prop="customer"
                  label="Customer : "
                >
                  <el-select
                    clearable
                    v-model="filter.customer_id"
                    placeholder="Select Customer"
                    class="w-100"
                    :disabled="selectTimePeriod === ''"
                  >
                    <!-- Render the header row once -->
                  <template v-if="customers.length > 0">
                    <div class="option-content option-header">
                      <span class="option-item">Name</span>
                      <span class="option-item">Phone</span>
                    </div>
                  </template>
                    <el-option
                      v-for="(item, index) in customers"
                      :key="item.id || index"
                      :label="item.full_name || 'undifined'"
                      :value="item.id || 'undifined'"
                      @click="handleSelectCustomer(item.id, item.full_name)"
                    >
                      <div class="option-content option-row">
                        <span class="option-item">{{ item.full_name }}</span>
                        <span class="option-item">{{ item.phone }}</span>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
                <!-- select customer dropdown end -->
              </el-col>


              <!-- select chargers dropdown -->
              <el-col
                v-if="hasCharger"
                :style="$vuetify.display.width <= 800 ? 'max-width: 100%;' :  $vuetify.display.width <= 1400 ? 'max-width: 95%; padding-left: 10px;' : 'max-width: 95%; padding-left: 10px;'"
                class="pr-0 mt-20"
                :class="
                  $store.state.auth.user == null ||
                  !$store.state.auth.user.is_admin
                    ? 'pl-0'
                    : ''
                "
                :span="
                  $vuetify.display.width >= 1400
                    ? 8
                    : $vuetify.display.width <= 800
                    ? 24
                    : 12
                "
              >
              <div >
                <el-form-item
                  class="label-style"
                  prop="charger"
                  :style="$vuetify.display.width < 500 ? '' : ''"
                  :label="selectedDeleteBy === 'port' ? 'Charger Ports: ' : selectedDeleteBy === 'site' ? 'Charger Sites: ' : selectedDeleteBy === 'charger' ? 'Chargers: ' : 'Select Delete By'"
                >
                  <el-select
                    v-if="selectedDeleteBy == `charger`"
                    v-model="filter.charger_name"
                    class="w-100"
                    :style="{'max-width': $vuetify.display.width <= 630 ? '320px' : ''}"
                    filterable
                    clearable
                    :loading="chargerLoading"
                    placeholder="Select Charger (search by charger name)"
                    :width="
                    $vuetify.display.width >= 1400
                      ? '100%'
                      : $vuetify.display.width <= 700
                      ? '60%'
                      : '100%'"
                  >
                  <template v-if="chargers.length > 0">
                    <div class="option-content option-header" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                      <span class="option-item">Site Name</span>
                      <span class="option-item">Charger Name</span>
                    </div>
                  </template>

                  <el-option
                      :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''"
                      v-for="(item, index) in chargers_dropdown"
                      :key="item.label || index"
                      :label="item.label || 'undifined'"
                      :value="item.value || 'undifined'"
                      @click="handleSelectCharger('charger', item.value)"
                    >
                      <div class="option-content option-row"
                        :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''"
                        >
                        <span class="option-item">{{ item.site_label }}</span>
                        <span class="option-item">{{ item.label }}</span>
                      </div>
                    </el-option>
                  </el-select>


                  <el-select
                    v-if="this.selectedDeleteBy == 'port'"
                    v-model="filter.charger_name"
                    class="w-100"
                    :style="{'max-width': $vuetify.display.width <= 630 ? '320px' : ''}"
                    filterable
                    clearable
                    :loading="portLoading"
                    placeholder="Select Charger Port (search by port name)"
                    :width= "$vuetify.display.width >= 1400
                      ? '100%'
                      : $vuetify.display.width <= 700
                      ? '60%'
                      : '100%'"
                  >
                  <template v-if="chargers.length > 0">
                    <div class="option-content option-header" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                      <span class="option-item">Site Name</span>
                      <span class="option-item">Charger Name</span>
                      <span class="option-item">Port Name</span>
                      <!-- <span class="option-item">Unallocated Sessions</span> -->
                    </div>
                  </template>
                    <el-option
                      v-for="(item, index) in charger_ports_dropdown"
                      :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''"
                      :key="item.label || index"
                      :label="item.label || 'undifined'"
                      :value="item.value || 'undifined'"
                      @click="handleSelectCharger('port', item.value)"
                    >
                      <div class="option-content option-row"  :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                        <span class="option-item">{{ item.site_label }}</span>
                        <span class="option-item">{{ item.charger_label }}</span>
                        <span class="option-item">{{ item.label }}</span>
                        <!-- <span class="option-item">{{ item.count }}</span> -->
                      </div>
                    </el-option>
                  </el-select>

                  <el-select
                    v-if="this.selectedDeleteBy == 'site'"
                    v-model="filter.charger_name"
                    class="w-100"
                    :style="{'max-width': $vuetify.display.width <= 630 ? '320px' : ''}"
                    filterable
                    clearable
                    :loading="siteLoading"
                    placeholder="Select Charger Site (search by site name)"
                    :width= "$vuetify.display.width >= 1400
                      ? '100%'
                      : $vuetify.display.width <= 700
                      ? '60%'
                      : '100%'"
                  >
                  <template v-if="chargers.length > 0">
                    <div class="option-content option-header" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                      <span class="option-item">Site Name</span>
                      <!-- <span class="option-item">Unallocated Sessions</span> -->
                    </div>
                  </template>
                    <el-option
                      v-for="(item, index) in charger_sites_dropdown"
                      :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''"
                      :key="item.label || index"
                      :label="item.label || 'undifined'"
                      :value="item.value || 'undifined'"
                      @click="handleSelectCharger('site', item.value)"
                    >
                      <div class="option-content option-row" :style="$vuetify.display.width < 470 ? 'max-width: 300px;' : $vuetify.display.width < 800 ? 'max-width: 100%;' : ''">
                        <span class="option-item">{{ item.label }}</span>
                        <!-- <span class="option-item">{{ item.count }}</span> -->
                      </div>

                    </el-option>
                  </el-select>


                </el-form-item>
              </div>
              </el-col>
              </el-row>


              <!-- select charger dropdown end -->
            </el-row>
          </el-space>



        </el-form>
        <!-- delete submite button -->
        <el-row v-if="(selectedDeleteBy == `customer`) && showDeleteButton && showTimePicker && selectedCustomer.customer_id && selected_to_delete.id > 0" gutter=20 class="float-right mt-5 width-100-p">
          <el-col
            :span="$vuetify.display.width >= 700 ? 12 : 24"
            :offset="$vuetify.display.width >= 1400 ? 4 : 0"
            class="px-1 y-center height-50"
            :class="$vuetify.display.width < 700 ? 'py-2 x-end' : 'height-100-p'"
          >
            <el-button
              color="#ddf0ac"
              @click="handleDeleteUnallocatedSession"
              class="height-40 rounded-3"
              :class="$vuetify.display.width < 700 ? 'x-end' : 'x-y-center'"
            >
              <svg class="stroke-icon width-20 height-20">
                <use href="@/assets/svg/icon-sprite.svg#stroke-refresh"></use>
              </svg>
              <span class="moderat-btn-apply pl-3"> Delete </span>
            </el-button>
          </el-col>
        </el-row>


        <el-row v-if="(selectedDeleteBy != `customer`) && showDeleteButton && showTimePicker && selected_to_delete.id && selected_to_delete.delete_by" gutter=20 class="float-right mt-5 width-100-p">
          <el-col
            :span="$vuetify.display.width >= 700 ? 12 : 24"
            :offset="$vuetify.display.width >= 1400 ? 4 : 0"
            class="px-1 y-center height-50"
            :class="$vuetify.display.width < 700 ? 'py-2 x-end' : 'height-100-p'"
          >
            <el-button
                @click="handleDeleteUnallocatedSession"
                class="custom-filter-button-apply"
            >
            <svg class="width-112 height-40">
                <use
                    href="@/assets/svg/newSvgIcon.svg#tableDeleteButton"
                ></use>
                </svg>
            </el-button>
          </el-col>
        </el-row>
      </div>
      </el-col>

    </el-row>
    </el-col>

  </el-row>

  <!-- created at date preview dialog -->
  <DialogDetail
    :open_modal="previewDialogVisible"
    :loading="previewLoading"
    :table-data="previewSessionLogs"
    :preview-total-count="previewTotalCount"
    :preview-count="previewCount"
    :created-at-date="selectedCreatedAtDate"
    :customer-name="selectedCustomer.full_name"
    @close_modal="handleClosePreviewDialog"
  />





</template>

<script>
  import UserService from "@/services/user.service";
  import { ElMessageBox } from "element-plus";
  import userService from "@/services/user.service";
  import DialogDetail from "./dialogDetail.vue";


  export default {
    components: {
      DialogDetail,
    },

    props: {
      monitoringPeriods: {
        type: Array,
        default: null,
      },
      customerData: {
        type: Array,
        default: null,
      },
      timeOfDayGroupByListProp: {
        type: Array,
        default: null,
      },
      hasGroupBy: {
        type: Boolean,
        default: false,
      },
      hasPeriod: {
        type: Boolean,
        default: false,
      },
      hasCustomDate: {
        type: Boolean,
        default: false,
      },
      hasCharger: {
        type: Boolean,
        default: false,
      },
      hasCustomer: {
        type: Boolean,
        default: true,
      },
    },

    watch: {
      'monitoringPeriods' : {
        handler: function(newVal) {
          this.fromParentMonitoringPeriods = newVal;

          // Only call fetchMonitoringPeriod if we have valid data
          if (newVal && newVal.data && newVal.data.monitoring_periods) {
            this.$nextTick(() => {
              this.fetchMonitoringPeriod();
            });
          }
        },
        immediate: true,
        deep: true,
      },
      'customerData' : {
        handler: function(newVal) {
          this.fromParentCustomerData = newVal;
          console.log("fromParentCustomerData", this.fromParentCustomerData);
          if (newVal && newVal.data && newVal.data.customers) {
            this.customer_unallocated_sessions = [];
            this.customer_chargers = [];

            this.fetchCustomerData();

          }
        },
        immediate: true,
        deep: true,
      },
      // reset datetime range when above limite period
      'deleteByDatetime.startDate'(newVal) {

        if(newVal < this.filter.startDate) {
          this.deleteByDatetime.startDate = this.filter.startDate;
          this.tempStartDate = this.filter.startDate;
          let MessageBox = `
          <span class="moderat-meGreen">Start date cannot be before the start of</span><br>
          <span class="moderat-meGreen">${this.selectTimePeriod.replace("current_mp", "Current MP").replace("revision_mp", "Revision MP")}: ${this.filter.startDate}</span><br>`;
          return ElMessageBox.alert(
            MessageBox,
            {
              confirmButtonText: "OK",
              type: "error",
              dangerouslyUseHTMLString: true,
            }
          ).then().catch(()=>{return;});
        }
        if(newVal > this.filter.endDate) {
          this.deleteByDatetime.startDate = this.filter.startDate;
          this.tempStartDate = this.filter.startDate;
          let MessageBox = `
          <span class="moderat-meGreen">Start date cannot be after the end of</span><br>
          <span class="moderat-meGreen">${this.selectTimePeriod.replace("current_mp", "Current MP").replace("revision_mp", "Revision MP")}: ${this.filter.endDate}</span><br>`;
          return ElMessageBox.alert(
            MessageBox,
            {
              confirmButtonText: "OK",
              type: "error",
              dangerouslyUseHTMLString: true,
            }
          ).then().catch(()=>{return;});
        }
        if(newVal == null) {
          this.deleteByDatetime.startDate = this.filter.startDate;
          this.tempStartDate = this.filter.startDate;
        }
      },
      'deleteByDatetime.endDate'(newVal){
        if(newVal > this.filter.endDate) {
          this.deleteByDatetime.endDate = this.filter.endDate;
          this.tempEndDate = this.filter.endDate;
          let MessageBox = `
          <span class="moderat-meGreen">End date cannot be after the end of</span><br>
          <span class="moderat-meGreen">${this.selectTimePeriod.replace("current_mp", "Current MP").replace("revision_mp", "Revision MP")}: ${this.filter.endDate}</span><br>`;
          return ElMessageBox.alert(
            MessageBox,
            {
              confirmButtonText: "OK",
              type: "error",
              dangerouslyUseHTMLString: true,
            }
          ).then().catch(()=>{return;});
        }
        if(newVal < this.filter.startDate) {
          this.deleteByDatetime.endDate = this.filter.endDate;
          this.tempEndDate = this.filter.endDate;
          let MessageBox = `
          <span class="moderat-meGreen">End date cannot be before the start of</span><br>
          <span class="moderat-meGreen">${this.selectTimePeriod.replace("current_mp", "Current MP").replace("revision_mp", "Revision MP")}: ${this.filter.startDate}</span><br>`;
          return ElMessageBox.alert(
            MessageBox,
            {
              confirmButtonText: "OK",
              type: "error",
              dangerouslyUseHTMLString: true,
            }
          ).then().catch(()=>{return;});
        }
        if(newVal == null) {
          this.deleteByDatetime.endDate = this.filter.endDate;
          this.tempEndDate = this.filter.endDate;
        }
      },
      // reset datetime range when above limite period

      'customDate'(newVal) {
        if(!newVal) {
          this.resetAll();
        }
        if(newVal) {
          this.fetchMonitoringPeriod();
        }
      },

      'selectedDeleteBy'(newVal) {
        // console.log("newVal select delete by", newVal);
        this.selected_to_delete.id = null;
        this.selected_to_delete.delete_by = null;

        if (newVal === "created_at") {
          this.resetCreatedAtState();
          return;
        }

        if(newVal == "charger") {
          this.switchChargerDropdownData('charger');
        }
        if(newVal == "site") {
          this.switchChargerDropdownData('site');
        }
        if(newVal == "port") {
          this.switchChargerDropdownData('port');
        }
      }
    },

    computed: {
      showTimePicker(){
        if(this.selectedMonitorPeriodId === null || this.selectedMonitorPeriodId === undefined){
          return false;
        } else {
          return true;
        }
      },

      showDeleteButton(){
        if(this.deleteByDatetime.startDate === null || this.deleteByDatetime.endDate === null || this.selectedMonitorPeriodId === null || this.selectedMonitorPeriodId === undefined){
          return false;
        } else {
          return true;
        }
      },


    },

    data() {
      return {
        allInOneChargerData: null,
        fetchedTimePeriod: [],
        selectedMonitorPeriodId: null,

        // radio select delete by charger, site, port
        selectedDeleteBy: 'charger', // default selected delete by charger
        // radio select time period
        selectTimePeriod: '', // default selected time period

        customDate: false,
        customers: [], //customer dropdown list
        chargers: [], // charger dropdown list

        customer_unallocated_sessions: [],
        customer_chargers: [],
        customer_charger_ports: [],
        customer_charger_sites: [],

        chargers_dropdown: [],
        charger_ports_dropdown: [],
        charger_sites_dropdown: [],

        unallocated_charger_dropdown: [],

        // selected customer from first dropdown
        selectedCustomer: {
            customer_id: null,
            full_name: null,
        },


        selected_to_delete: {
          delete_by: null,
          id: null,
        },

        tempStartDate: null,
        tempEndDate: null,

        deleteByDatetime: {
          startDate: null,
          endDate: null,
          uniq_charger_id: null,
        },

        deleteRequest: null,

        filter: {
          customer_id: null,
          state: "All",
          startDate: null,
          endDate: null,
          groupBy: null,
          groupByItem: null,
          charger_name: null,
        },

        chargerLoading: false,
        portLoading: false,
        siteLoading: false,

        createdAtDateTimeRange: [null, null],
        createdAtFilter: {
          start_date: null,
          end_date: null,
          start_time: null,
          end_time: null,
        },
        sessionLogsByCreatedAt: [],
        createdAtListLoading: false,
        selectedCreatedAtDate: null,
        previewDialogVisible: false,
        previewSessionLogs: [],
        previewTotalCount: 0,
        previewCount: 0,
        previewLoading: false,
      };
    },
    mounted() {

        this.resetAll();
    },
      methods: {
        resetCreatedAtState() {
          this.createdAtDateTimeRange = [null, null];
          this.createdAtFilter = {
            start_date: null,
            end_date: null,
            start_time: null,
            end_time: null,
          };
          this.sessionLogsByCreatedAt = [];
          this.selectedCreatedAtDate = null;
          this.previewDialogVisible = false;
          this.previewSessionLogs = [];
          this.previewTotalCount = 0;
          this.previewCount = 0;
        },

        handleCreatedAtCustomerChange(customerId) {
          if (!customerId) {
            this.selectedCustomer.customer_id = null;
            this.selectedCustomer.full_name = null;
            this.sessionLogsByCreatedAt = [];
            return;
          }
          const customer = this.customers.find((item) => item.id === customerId);
          this.selectedCustomer.customer_id = customerId;
          this.selectedCustomer.full_name = customer ? customer.full_name : null;
          this.fetchSessionLogsByCreatedAt();
        },

        handleCreatedAtDateRangeChange(value) {
          if (value && value.length === 2) {
            this.createdAtFilter.start_time = value[0];
            this.createdAtFilter.end_time = value[1];
            this.createdAtFilter.start_date = value[0] ? value[0].split(" ")[0] : null;
            this.createdAtFilter.end_date = value[1] ? value[1].split(" ")[0] : null;
          } else {
            this.createdAtFilter.start_time = null;
            this.createdAtFilter.end_time = null;
            this.createdAtFilter.start_date = null;
            this.createdAtFilter.end_date = null;
          }

          if (this.selectedCustomer.customer_id) {
            this.fetchSessionLogsByCreatedAt();
          }
        },

        async fetchSessionLogsByCreatedAt() {
          if (!this.selectedCustomer.customer_id) {
            let MessageBox = `<span class="moderat-meGreen-bold">Please select a customer before loading upload dates.</span>`;
            ElMessageBox.alert(
              MessageBox,
              {
                confirmButtonText: "OK",
                type: "warning",
                dangerouslyUseHTMLString: true,
              }
            ).then().catch(() => { return; });
            this.sessionLogsByCreatedAt = [];
            return;
          }

          this.createdAtListLoading = true;
          try {
            const body = {
              command: "get_session_log_by_created_at",
              customer_id: this.selectedCustomer.customer_id,
            };
            if (this.createdAtFilter.start_date) {
              body.start_date = this.createdAtFilter.start_date;
            }
            if (this.createdAtFilter.end_date) {
              body.end_date = this.createdAtFilter.end_date;
            }
            if (this.createdAtFilter.start_time) {
              body.start_time = this.createdAtFilter.start_time;
            }
            if (this.createdAtFilter.end_time) {
              body.end_time = this.createdAtFilter.end_time;
            }

            const response = await userService.DeleteUnallocatedSession(body);
            const result = response.data;

            if (result.code !== 1000) {
              let MessageBox = `<span class="moderat-meGreen-bold">${result.message}</span>`;
              await ElMessageBox.alert(
                MessageBox,
                {
                  confirmButtonText: "OK",
                  type: "error",
                  dangerouslyUseHTMLString: true,
                }
              ).then().catch(() => { return; });
              this.sessionLogsByCreatedAt = [];
              return;
            }

            this.sessionLogsByCreatedAt = (result.session_logs || []).slice().sort(
              (a, b) => b.created_at_date.localeCompare(a.created_at_date)
            );
          } catch (error) {
            console.error("Error fetching session logs by created at:", error);
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
              this.$router.push({ path: "/" });
            } else {
              let MessageBox = `<span class="moderat-meGreen-bold">An error occurred while fetching upload dates. Please try again.</span>`;
              ElMessageBox.alert(
                MessageBox,
                {
                  confirmButtonText: "OK",
                  type: "error",
                  dangerouslyUseHTMLString: true,
                }
              ).then().catch(() => { return; });
            }
            this.sessionLogsByCreatedAt = [];
          } finally {
            this.createdAtListLoading = false;
          }
        },

        async handleViewCreatedAtPreview(createdAtDate) {
          if (!this.selectedCustomer.customer_id) {
            return;
          }

          this.selectedCreatedAtDate = createdAtDate;
          this.previewDialogVisible = true;
          this.previewLoading = true;
          this.previewSessionLogs = [];
          this.previewTotalCount = 0;
          this.previewCount = 0;

          try {
            const body = {
              command: "session_logs_for_delete_by_created_at_date",
              customer_id: this.selectedCustomer.customer_id,
              created_at_date: createdAtDate,
            };

            const response = await userService.DeleteUnallocatedSession(body);
            const result = response.data;

            if (result.code !== 1000) {
              let MessageBox = `<span class="moderat-meGreen-bold">${result.message}</span>`;
              await ElMessageBox.alert(
                MessageBox,
                {
                  confirmButtonText: "OK",
                  type: "error",
                  dangerouslyUseHTMLString: true,
                }
              ).then().catch(() => { return; });
              this.previewDialogVisible = false;
              return;
            }

            this.previewSessionLogs = result.session_logs || [];
            this.previewTotalCount = result.total_session_logs || 0;
            this.previewCount = result.preview_count || this.previewSessionLogs.length;
          } catch (error) {
            console.error("Error fetching session log preview:", error);
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
              this.$router.push({ path: "/" });
            } else {
              let MessageBox = `<span class="moderat-meGreen-bold">An error occurred while fetching preview records. Please try again.</span>`;
              ElMessageBox.alert(
                MessageBox,
                {
                  confirmButtonText: "OK",
                  type: "error",
                  dangerouslyUseHTMLString: true,
                }
              ).then().catch(() => { return; });
            }
            this.previewDialogVisible = false;
          } finally {
            this.previewLoading = false;
          }
        },

        handleClosePreviewDialog() {
          this.previewDialogVisible = false;
          this.selectedCreatedAtDate = null;
          this.previewSessionLogs = [];
          this.previewTotalCount = 0;
          this.previewCount = 0;
        },

        async handleDeleteByCreatedAt(row) {
          const createdAtDate = row?.created_at_date ?? this.selectedCreatedAtDate;
          const totalCount = row?.total_session_logs ?? this.previewTotalCount;

          if (!this.selectedCustomer.customer_id || !createdAtDate) {
            return;
          }

          let MessageBox = `
          <span class="moderat-meGreen">Do you want to proceed with deleting unallocated sessions for:</span><br>
          <span class="moderat-meGreen">Customer: </span>
          <span class="moderat-meGreen-bold">${this.selectedCustomer.full_name}</span><br>
          <span class="moderat-meGreen">Upload date: </span>
          <span class="moderat-meGreen-bold">${createdAtDate}</span><br>
          <span class="moderat-meGreen">Total records: </span>
          <span class="moderat-meGreen-bold">${totalCount}</span><br>`;

          return ElMessageBox.confirm(
            MessageBox,
            "Confirm Delete",
            {
              confirmButtonText: "Yes",
              cancelButtonText: "Cancel",
              type: "confirm",
              dangerouslyUseHTMLString: true,
            }
          ).then(async () => {
            try {
              const body = {
                command: "delete_session_log_by_created_at",
                customer_id: this.selectedCustomer.customer_id,
                created_at_date: createdAtDate,
              };

              const response = await userService.DeleteUnallocatedSession(body);
              const result = response.data;

              if (result.code !== 1000 || result.success === false) {
                let errorBox = `<span class="moderat-meGreen-bold">${result.message}</span>`;
                await ElMessageBox.alert(
                  errorBox,
                  {
                    confirmButtonText: "OK",
                    type: "error",
                    dangerouslyUseHTMLString: true,
                  }
                ).then().catch(() => { return; });
                return;
              }

              const deletedCount = result.deleted_count ?? totalCount;
              let successBox = `<span class="moderat-meGreen-bold">Deleted ${deletedCount} unallocated session log(s) successfully.</span>`;
              await ElMessageBox.alert(
                successBox,
                {
                  confirmButtonText: "OK",
                  type: "success",
                  dangerouslyUseHTMLString: true,
                }
              ).then().catch(() => { return; });

              if (this.selectedCreatedAtDate === createdAtDate) {
                this.previewDialogVisible = false;
                this.handleClosePreviewDialog();
              }
              await this.fetchSessionLogsByCreatedAt();
              this.$emit("afterDelete");
            } catch (error) {
              console.error("Error during delete by created at:", error);
              if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                this.$router.push({ path: "/" });
              } else {
                let errorBox = `<span class="moderat-meGreen-bold">An error occurred during the delete operation. Please try again.</span>`;
                ElMessageBox.alert(
                  errorBox,
                  {
                    confirmButtonText: "OK",
                    type: "error",
                    dangerouslyUseHTMLString: true,
                  }
                ).then().catch(() => { return; });
              }
            }
          }).catch(() => {
            console.log("Delete cancelled");
          });
        },

        updateDate(type) {
          if(type == 'start') {
            this.deleteByDatetime.startDate = this.tempStartDate; // Set the actual startDate
            console.log("Start date updated:", this.deleteByDatetime.startDate);
          } else if(type == 'end') {
            this.deleteByDatetime.endDate = this.tempEndDate; // Set the actual endDate
            console.log("End date updated:", this.deleteByDatetime.endDate);
          }
        },

        handleSelectedMP(mpID) {
            this.filter.startDate = this.fetchedTimePeriod.find(item => item.id == mpID).start_date;
            this.filter.endDate = this.fetchedTimePeriod.find(item => item.id == mpID).end_date;
            this.tempStartDate = this.fetchedTimePeriod.find(item => item.id == mpID).start_date;
            this.tempEndDate = this.fetchedTimePeriod.find(item => item.id == mpID).end_date;
            this.updateDate("start");
            this.updateDate("end");
        },


      resetTempDate(type) {
        if(type == 'start') {
          this.tempStartDate = this.filter.startDate;
        } else if(type == 'end') {
          this.tempEndDate = this.filter.endDate;
        }
      },

      formatTableLabel(label) {

        let splitLabel = label.toLowerCase().split("_");
        for (let i = 0; i < splitLabel.length; i++) {
          splitLabel[i] = splitLabel[i].replace(/\b\w/g, char => char.toUpperCase());
        }
        label = splitLabel.join(" ");
        return label;
        },


      /**
       * Switches the time period based on the selected event and updates the filter and deleteByDatetime dates.
       *
       * Description:
       * - Logs the event to the console for debugging purposes.
       * - Switches the time period based on the event type ("current_mp" or "revision_mp").
       * - Updates the `filter` and `deleteByDatetime` objects with the corresponding start and end dates from the `fetchedTimePeriod` array.
       *
       * @param {string} event - The event type indicating the time period to switch to (e.g., "current_mp", "revision_mp").
       */
       switchTimePeriod(event) {
        this.selectedMonitorPeriodId = null;
        this.deleteByDatetime.startDate = null;
        this.deleteByDatetime.endDate = null;
        this.tempStartDate = null;
        this.tempEndDate = null;

        // console.log(event);
        switch (event) {
          case "current_mp":
            this.filterStatus = "current";
            this.fetchMonitoringPeriod(this.filterStatus);
            break;
          case "revision_under_audit_mp":
            this.filterStatus = "revision_under_audit";
            this.fetchMonitoringPeriod(this.filterStatus);
            break;
          case "revision_issue_requested_mp":
            this.filterStatus = "revision_issue_requested";
            this.fetchMonitoringPeriod(this.filterStatus);
            break;
          default:
            this.filterStatus = null;
            this.fetchMonitoringPeriod(this.filterStatus);
            break;
        }
      },

        async handleDeleteUnallocatedSession() {

            let type = this.selectedDeleteBy;

            switch (type) {
              case "customer":
                this.deleteRequest={
                  command: "delete",
                  delete_by: "customer",
                  customer_id: this.selectedCustomer.customer_id,
                  start_time: this.deleteByDatetime.startDate,
                  end_time: this.deleteByDatetime.endDate,
                  mp_id: this.selectedMonitorPeriodId,
                }
                break;
              case "charger":
                this.deleteRequest={
                  command: "delete",
                  delete_by: "charger",
                  customer_id: this.selectedCustomer.customer_id,
                  charger_name : this.selected_to_delete.id,
                  start_time: this.deleteByDatetime.startDate,
                  end_time: this.deleteByDatetime.endDate,
                  mp_id: this.selectedMonitorPeriodId,
                }
                break;
              case "site":
                this.deleteRequest={
                  command: "delete",
                  delete_by: "site",
                  customer_id: this.selectedCustomer.customer_id,
                  site_name : this.selected_to_delete.id,
                  start_time: this.deleteByDatetime.startDate,
                  end_time: this.deleteByDatetime.endDate,
                  mp_id: this.selectedMonitorPeriodId,
                  }
                break;
              case "port":
                this.deleteRequest={
                  command: "delete",
                  delete_by: "port",
                  customer_id: this.selectedCustomer.customer_id,
                  port_name : this.selected_to_delete.id,
                  start_time: this.deleteByDatetime.startDate,
                  end_time: this.deleteByDatetime.endDate,
                  mp_id: this.selectedMonitorPeriodId,
                }
                break;

              default:
                break;
            }




            // console.log("this.filter", this.filter);
            if(this.selectedDeleteBy == "customer") {
              let MessageBox = `
              <span class="moderat-meGreen">Do you want to proceed with deleting sessions for <span> <br> 
              <span class="moderat-meGreen"> customer : </span> <br>
              <span class="moderat-meGreen-bold">${this.selectedCustomer.full_name}</span><br>
              <span class="moderat-meGreen">Monitoring Period : </span><br>
              <span class="moderat-meGreen">Start time: ${this.deleteByDatetime.startDate.replace('T', ' ')}</span><br>
              <span class="moderat-meGreen">End time: ${this.deleteByDatetime.endDate.replace('T', ' ')}</span><br>`;
              return ElMessageBox.confirm(
                MessageBox,
                "confirm",
                {
                  confirmButtonText: "Yes",
                  cancelButtonText: "Cancel",
                  type: "confirm",
                  dangerouslyUseHTMLString: true,
                }
              ).then(() => {
                this.submitDelete();
              }
              ).catch(() => {
                console.log("Delete cancelled");
              });
            } else {
              let MessageBox = `
              <span class="moderat-meGreen">Do you want to proceed with deleting sessions for ${this.selectedDeleteBy} of </span>
              <span class="moderat-meGreen">${this.selectedDeleteBy == "charger" ? 'charger name: ' + this.selected_to_delete.id : this.selectedDeleteBy == "site" ? 'site name: ' + this.selected_to_delete.id : this.selectedDeleteBy == "port" ? 'charger name: ' + this.selected_to_delete.id : this.selected_to_delete.id}?</span><br>
              <span class="moderat-meGreen"> customer : </span> <br>
              <span class="moderat-meGreen-bold">${this.selectedCustomer.full_name}</span><br>
              <span class="moderat-meGreen">Monitoring Period : </span><br>
              <span class="moderat-meGreen">Start time: ${this.deleteByDatetime.startDate.replace('T', ' ')}</span><br>
              <span class="moderat-meGreen">End time: ${this.deleteByDatetime.endDate.replace('T', ' ')}</span><br>`;
              return ElMessageBox.confirm(
                MessageBox,
                "confirm",
                {
                  confirmButtonText: "Yes",
                  cancelButtonText: "Cancel",
                  type: "confirm",
                  dangerouslyUseHTMLString: true,
                }
              ).then(() => {
                this.submitDelete();
              }
              ).catch(() => {
                console.log("Delete cancelled");
              });
            }
        },

        // submiteDelete
        /**
         * Submits the delete sessions request.
         *
         * Description:
         * - Displays an initial alert indicating that the delete request has been submitted.
         * - Sends a request to delete sessions by unique charger ID using the `deleteRequest` object.
         * - If the deletion is unsuccessful, displays an error alert with the result message.
         * - If the deletion is successful, displays a success alert with detailed information about the deletion.
         * - Resets the form and emits an `afterDelete` event upon successful deletion.
         * - Logs any errors that occur during the delete operation and displays an error alert.
         *
         * @returns {Promise<void>} - A promise that resolves when the delete operation is completed.
         */
        async submitDelete() {

          try {

            let MessageBox = `<span class="moderat-meGreen-bold">Delete request submitted!</span>`;
            await ElMessageBox.alert(
              MessageBox,
              {
                confirmButtonText: "OK",
                type: "success",
                dangerouslyUseHTMLString: true,
              }
            ).then().catch(()=>{return;});

            // console.log("submit delete");

            let result = null;

            const res = await userService.DeleteUnallocatedSession(this.deleteRequest);
            result = res.data;
            // console.log("result", result);

            if (!result.success) {
              let MessageBox = `<span class="moderat-meGreen-bold">${result.message}</span>`;
              await ElMessageBox.alert(
                MessageBox,
                {
                  confirmButtonText: "OK",
                  type: "error",
                  dangerouslyUseHTMLString: true,
                }
              ).then().catch(()=>{return;});

            } else {
              let MessageBox = `<span class="moderat-meGreen-bold">${result.message}</span>`;
              await ElMessageBox.alert(
                MessageBox,
              {
                confirmButtonText: "OK",
                type: "success",
                dangerouslyUseHTMLString: true,
              }
            ).then().catch(()=>{return;});

            this.resetAll();
            this.$emit("afterDelete");

            }

          } catch (error) {
            console.error("Error during delete operation", error);
            let MessageBox = `<span class="moderat-meGreen-bold">An error occurred during the delete operation. Please try again.</span>`;
            ElMessageBox.alert(
              MessageBox,
              {
                confirmButtonText: "OK",
                type: "error",
                dangerouslyUseHTMLString: true,
              }
            ).then().catch(()=>{return;});
          }
        },

        // handleReset
        resetAll() {
            this.chargers = [];
            this.chargers_dropdown= [];
            this.charger_ports_dropdown= [];
            this.charger_sites_dropdown= [];
            this.selectedCustomer.customer_id = null;
            this.selectedCustomer.full_name = null;
            this.selected_to_delete.delete_by = null;
            this.selected_to_delete.id = null;

            this.deleteByDatetime.uniq_charger_id = null;
            this.deleteByDatetime.startDate = null;
            this.deleteByDatetime.endDate = null;

            this.selectedMonitorPeriodId = null;

            this.filter = {
              customer_id: null,
              state: "All",
              startDate: null,
              endDate: null,
              groupBy: null,
              groupByItem: null,
              charger_name: null,
            };

            this.fetchedTimePeriod = [];
            this.fetchMonitoringPeriod();
            this.selectTimePeriod = '';
            this.resetCreatedAtState();
        },

        // handleSelectCustomer
        /**
         * Handles the selection of a customer.
         * @param {number} id - The ID of the selected customer.
         * @param {string} name - The full name of the selected customer.
         * Description:
         * - If the `id` is null, logs a message indicating that no customer ID was found.
         * - Sets the `customer_id` and `full_name` of `selectedCustomer` to the provided `id` and `name`.
         */
        async handleSelectCustomer(id, name) {
          if (id == null) {
            console.log("no customer id found");
          }
          this.selectedCustomer.customer_id = id;
          this.selectedCustomer.full_name = name;

          if (this.selectedDeleteBy === "created_at") {
            await this.fetchSessionLogsByCreatedAt();
            return;
          }

          this.selected_to_delete.id = id;


          this.filter.charger_name = null;


          // console.log(this.selectedCustomer);

          // let foundCharger = this.customer_chargers.find((item) => item.customer_id == id);
          let foundCharger = this.customer_unallocated_sessions.find((item) => item.customer_id == id);

          if (!foundCharger) {
            // await this.fetchChargerData(id);
            await this.fetchAllInOneChargerData(id);
          } else {
            await this.processChargerData(id, this.allInOneChargerData);
          }




          // fetch charger data to update charger list after selecting customer

        },



        async handleSelectCharger(delete_by_input, delete_key_input) {
          this.selected_to_delete.delete_by = delete_by_input;
          this.selected_to_delete.id = delete_key_input;
        },



        /**
         * Switches the charger dropdown data based on the selected event type.
         *
         * Description:
         * - Gets the selected customer ID.
         * - If the customer ID is not null:
         *   - Tries to switch the dropdown data based on the event type.
         *   - Updates the `chargers`, `chargers_dropdown`, `charger_sites_dropdown`, or `charger_ports_dropdown` arrays accordingly.
         * - Handles errors by logging them.
         * - If the customer ID is null, logs a message indicating that no customer ID was found and clears the `chargers` array.
         *
         * @param {string} event - The event type (e.g., "charger", "site", "port").
         * @returns {Promise<void>} - A promise that resolves when the dropdown data is switched.
         */
        async switchChargerDropdownData(event) {
          // console.log(event);


          // get selected customer id
          let id = this.selectedCustomer.customer_id;

          if (id != null) {
            // this.chargers = [];

            try {
                  // console.log("customer_unallocated_sessions charger", this.customer_unallocated_sessions);
                  this.unallocated_chargers = this.customer_unallocated_sessions.find((item) => item.customer_id == id).chargers;
                  // console.log("unallocated_chargers", this.unallocated_chargers);

                  this.unallocated_charger_dropdown = this.unallocated_chargers.map((item) => {
                    return {
                      id: item.id,
                      port: item.port,
                      site_title: item.site_title,
                      charger_name: item.charger_id,
                      start_time: item.start_time,
                    };
                  });
                  // console.log("unallocated_charger_dropdown", this.unallocated_charger_dropdown);

              switch (event) {
                case "charger":
                  this.chargers = this.customer_chargers.find((item) => item.customer_id == id).chargers;
                  this.chargers_dropdown = this.chargers.map((item) => {
                    return {
                      label: item.label,
                      value: item.label,
                      // count: item.count,
                      charger_label: item.sessions[0].charger_id,
                      port_label: item.sessions[0].port,
                      site_label: item.sessions[0].site_title,

                      // sessions: item.sessions
                    };
                  });
                  break;
                case "site":
                  this.chargers = this.customer_charger_sites.find((item) => item.customer_id == id).charger_sites;
                  this.charger_sites_dropdown = this.chargers.map((item) => {
                    return {
                      label: item.label,
                      value: item.label,
                      // count: item.count,
                      // sessions: item.sessions
                      charger_label: item.sessions[0].charger_id,
                      port_label: item.sessions[0].port,
                      site_label: item.sessions[0].site_title,
                    };
                  });
                  // console.log("chargers", this.chargers);

                  // console.log("charger_sites_dropdown", this.charger_sites_dropdown);

                  break;
                case "port":
                  this.chargers = this.customer_charger_ports.find((item) => item.customer_id == id).charger_ports;
                  this.charger_ports_dropdown = this.chargers.map((item) => {
                    return {
                      label: item.label,
                      value: item.label,
                      // count: item.count,
                      // sessions: item.sessions
                      charger_label: item.sessions[0].charger_id,
                      port_label: item.sessions[0].port,
                      site_label: item.sessions[0].site_title,
                    };
                  });
                  break;

                default:
                  break;
                }

              } catch (error) {
                console.log(error);
              }

        } else {
          console.log("no customer id found");
          this.chargers = [];
        }

        },

      // fetchMonitoringPeriod for selected start and end date dropdown
       async fetchMonitoringPeriod(filterStatus) {

        try {
          const requestData = [];
          const allowedStatuses = [];
          allowedStatuses.push(filterStatus);

          const monitoringPeriodsRes = this.fromParentMonitoringPeriods;


          // Check if we have valid data before proceeding
          if (!monitoringPeriodsRes || !monitoringPeriodsRes.data || !monitoringPeriodsRes.data.monitoring_periods) {
            console.log("No monitoring periods data available yet, skipping fetchMonitoringPeriod");
            return;
          }

          requestData.push({
            "table_name": "monitoring_periods",
            "data": monitoringPeriodsRes.data.monitoring_periods,
          });
          
          const filteredData = requestData[0].data.filter((item) => allowedStatuses.includes(item.status));

          this.fetchedTimePeriod = filteredData;

          // console.log("fetchedTimePeriod", this.fetchedTimePeriod);
        } catch (error) {
          console.error("An error occurred while fetching the monitoring period:", error.message);
          let MessageBox = `<span class="moderat-meGreen-bold">Error fetching monitoring period:</span><br>
          <span class="moderat-meGreen">${error.message}</span>`;
          ElMessageBox.alert(
           MessageBox,
            {
              confirmButtonText: "OK",
              type: "error",
              dangerouslyUseHTMLString: true,
            }
          ).then().catch(()=>{return;});

          // this.showMP = false; // switch if show monitoring period radio and time picker
        }
      },

      async fetchCustomerData() {
          this.customers = await this.fromParentCustomerData.data.customers;
          this.loading = false;
      },

    async fetchAllInOneChargerData(id) {
      this.allInOneChargerData = null;
      if (id != null) {
        this.chargerLoading = true;

        let body = {
            command: "fetch",
            customer_id: id,
            start_date: this.deleteByDatetime.startDate,
            end_date: this.deleteByDatetime.endDate
          };

        try {
          const response = await UserService.DeleteUnallocatedSession(body);
          let data = response.data;
          // console.log("fetchAllInOneChargerData", data);


          this.allInOneChargerData = data;
          // Process data asynchronously
          await this.processChargerData(id, data);

        } catch (error) {
          console.log(error);
          if (error.response && error.response.status === 401) {
            this.$router.push({ path: "/" });
          }
        } finally {
          this.chargerLoading = false;
          await this.processChargerData(id, this.allInOneChargerData);
        }
      }
    },

    groupByField(data, field) {
      const grouped = {};
      data.forEach((item) => {
        const key = item[field];
        if (!grouped[key]) {
          grouped[key] = {
            value: key,
            // count: 1,
            sessions: [item],
          };
        } else {
          grouped[key].count += 1;
          grouped[key].sessions.push(item);
        }
      });

      return Object.values(grouped).map(group => (
      {
        label: group.value,
        value: group.value,
        // count: group.count,
        sessions: group.sessions,
      }));
    },

    async processChargerData(id, data) {

      const filter_unallocated_charger = data.unallocated_sessions;

      const dropdown_charger = this.groupByField(filter_unallocated_charger, "charger_id");
      const dropdown_port = this.groupByField(filter_unallocated_charger, "port");
      const dropdown_site = this.groupByField(filter_unallocated_charger, "site_title");

      // Use setTimeout to process data in chunks
      await new Promise((resolve) => {
        setTimeout(() => {
          this.customer_unallocated_sessions.push({
            customer_id: id,
            chargers: filter_unallocated_charger,
          });
          // console.log("chargers", this.customer_chargers);

          resolve();
        }, 0);
      });
      await new Promise((resolve) => {
        setTimeout(() => {
          this.customer_chargers.push({
            customer_id: id,
            chargers: dropdown_charger,
          });
          // console.log("chargers", this.customer_chargers);

          resolve();
        }, 0);
      });

      await new Promise((resolve) => {
        setTimeout(() => {
          this.customer_charger_ports.push({
            customer_id: id,
            charger_ports: dropdown_port,
          });
          // console.log("customer_charger_ports", this.customer_charger_ports);

          resolve();
        }, 0);
      });

      await new Promise((resolve) => {
        setTimeout(() => {
          this.customer_charger_sites.push({
            customer_id: id,
            charger_sites: dropdown_site,
          });
          // console.log("customer_charger_sites", this.customer_charger_sites);

          resolve();
        }, 0);
      });

      this.switchChargerDropdownData(this.selectedDeleteBy);
    },
      handleCustomDate() {
        this.$emit("filterHandle", this.filter);
      },
    },
  };
  </script>

  <style scoped>

  .el-dropdown-menu {
    background-color: #0d3937 !important;
    color: white !important;
    max-width: 300px;
  }

  .el-dropdown-menu__item {
    color: white !important;
  }

  .el-dropdown-menu__item:not(.is-disabled):focus {
    background-color: #547477 !important;
  }

  .label-color > label {
    color: white !important;
    width: 80px !important;
  }
  .label-color > div > div {
    height: 100% !important;
    display: flex !important;
    align-items: center;
  }

  .el-dropdown__list > .el-dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
  }

  .el-radio-button__inner {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .option-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .option-header {
    position: sticky;
    top:0;
    z-index: 1;
    font-weight: bold;
    background-color: #f2f2f2;
  }

  .option-item {
    color: var(--el-text-color-secondary);
    font-size: 13px;
    flex: 1;
    text-align: center;
    padding: 4px;
  }

  .warning-message {
  color: orangered;
  font-size: 12px;
  padding: 2px;
  border-radius: 5px;
}

.radio-label {
  color: #ffaa05;
  display: flex;
  align-items: center;
  height: 100%;
  justify-self: center;
}


.sublist {
  margin-top: 5px;
  margin-left: 10px;
  padding-left: 10px;
  border-left: 2px solid #ccc;
  font-size: 13px;
}
.sublist-item {
  margin-bottom: 4px;
}

  </style>